// Centralized socket event names — moved under hooks/socket for easier maintenance
export const SOCKET_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  PARCEL_STATUS_UPDATE: 'parcelStatusUpdate',
  RIDER_LOCATION_UPDATE: 'riderLocationUpdate',
  LEG_NOTIFICATION: 'leg_notification',
  REGISTER_DEVICE: 'registerDevice',
  UNREGISTER_DEVICE: 'unregisterDevice',
  REFRESH_PARCEL: 'refreshParcel',
  PARCEL_UPDATED: 'parcelUpdated', // custom window event
};

export const ALL_SOCKET_EVENTS = Object.values(SOCKET_EVENTS);

export default SOCKET_EVENTS;
